export const TOOLTIP_OPTIONS: Record<
  'showing' | 'offer' | 'eye' | 'tourNoMoreShowings' | 'tourShowingUnavailable',
  string
> = {
  showing:
    'You cannot Book a Showing as this listing is not represented by BrokerBay.',
  offer:
    'You cannot Register an Offer as this listing is not represented by BrokerBay.',
  eye: 'You cannot view this modal as this listing is not represented by BrokerBay.',
  tourNoMoreShowings:
    'You cannot add to a tour if showings are turned off for this listing',
  tourShowingUnavailable: 'You cannot add this listing to a tour',
};
